export type ShimmerCfg = {
	enabled: boolean;
	startOffsetMs: number;
	avgIntervalMs: number;
	maxConcurrent: number;
	durationMs: number;
	pulseLen: number;
	brightness: number;
	strokeWidth: number;
	glow: number;
};

export type ShimmerSlot = {
	edgeId: string;
	startMs: number;
	durationMs: number;
	pulseLen: number;
} | null;

export function nextPoissonInterval(avgMs: number, rand: () => number): number {
	const mean = Math.max(1, avgMs);
	const u = Math.min(0.999999, Math.max(1e-9, rand()));
	return -Math.log(1 - u) * mean;
}

export function pickRandomEdgeId(
	edgeIds: readonly string[],
	rand: () => number,
): string | undefined {
	if (edgeIds.length === 0) return undefined;
	const i = Math.min(edgeIds.length - 1, Math.floor(rand() * edgeIds.length));
	return edgeIds[i];
}

export function easeInOutSine(t: number): number {
	if (t <= 0) return 0;
	if (t >= 1) return 1;
	return 0.5 - 0.5 * Math.cos(Math.PI * t);
}
